import React, { useEffect, useState } from 'react'
import styles from './ScrollToTop.module.css'
import { FiArrowUp } from "react-icons/fi";

const ScrollToTop = () => {

    const [backToTopButton, setBackToTopButton] = useState(false)
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const progress = (window.scrollY / totalHeight) * 100;
            setScrollProgress(progress);

            if (window.scrollY > 100) {
                setBackToTopButton(true);
            } else {
                setBackToTopButton(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const radius = 24;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (scrollProgress / 100) * circumference;

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    return (
        <div>
            {
                backToTopButton && (
                    <div className={styles.scroll_btn_wrapper} onClick={scrollUp}>
                        <svg
                            className={styles.progress_ring}
                            width="60"
                            height="60"
                        >
                            <circle
                                stroke="#ccc"
                                fill="transparent"
                                strokeWidth="2"
                                r={radius}
                                cx="30"
                                cy="30"
                            />
                            <circle
                                stroke="#16a66a"
                                fill="transparent"
                                strokeWidth="2"
                                strokeLinecap="round"
                                r={radius}
                                cx="30"
                                cy="30"
                                strokeDasharray={circumference}
                                strokeDashoffset={strokeDashoffset}
                            />
                        </svg>
                        <span className={styles.scroll_to_top_btn}>
                            <FiArrowUp />
                        </span>
                    </div>
                )
            }
        </div>
    )
}

export default ScrollToTop